import React from 'react';
import { write, useSnap } from '../../store'
import toast from 'react-hot-toast';


function RussianWelcome() {
    const read = useSnap()


    return (

        <>

            <div className="flex flex-col">

            <h1 className=' text-3xl'>
                     добро пожаловать,
                 </h1>
                 <p>
                     Этот экзамен включает в себя {read.totalQuestions} вопросов, и у вас есть 60 секунд, чтобы ответить на вопросы по чтению и аудированию, 60 секунд на устную речь, а также различное время для письменной речи. Найдите тихое место для прохождения экзамена, так как ваш голос будет записан.
                 </p>
                 <br />
                 <p>
                     Вы увидите таймер для связанных вопросов в правом верхнем углу приложения, а ваша веб-камера будет записываться в левом верхнем углу.
                 </p>
                 <br />
                 <p>
                     Вам необходимо прочитать и согласиться с нашими условиями обслуживания, и для прохождения экзамена у вас должны быть активная веб-камера и микрофон.
                 </p>
                 <br />
                 <p>
                     Если ваша веб-камера не работает и вы не видите себя или микрофон сейчас подключен, кнопка запуска не будет активирована, и вы не сможете начать экзамен. Вы должны обязательно убедиться, что у вас есть работающая веб-камера и микрофон перед сдачей теста.
                 </p>
                 <br />
                 <p>
                     Вы должны убедиться, что ваше интернет-соединение в порядке, так как мы записываем ваш голос и ваше видео. Если вы отключены, вы можете использовать ту же ссылку, чтобы продолжить экзамен с того места, где вы остановились.
                 </p>
                 <br />
                 <p>
                     Ни в одном из вопросов с множественным выбором нет отрицательного момента, поэтому не стесняйтесь отвечать на все вопросы как можно подробнее.
                 </p>
                 <br />
                 <h1 className=' text-2xl'>
                    Если вы понимаете инструкции, вы можете нажать «Я ПОНИМАЮ» и начать экзамен. Удачи!
                 </h1>

             </div>
        </>
    )



}


export default RussianWelcome